<template>
  <body class="u-body u-xl-mode" data-lang="en"><header class="u-clearfix u-header u-valign-bottom-sm u-valign-bottom-xs u-header" id="sec-52d1">
      <a href="#" class="u-image u-logo u-image-1" data-image-width="498" data-image-height="505" title="Home">
        <img src="../../../assets/warranty-images/logo-anewday_1full_color.webp" class="u-logo-image u-logo-image-1">
      </a>
      <nav class="u-menu u-menu-one-level u-offcanvas u-menu-1">
        <div class="menu-collapse u-custom-font" style="font-size: 1.125rem; letter-spacing: 0px; font-family: Kanit;">
          <a class="u-button-style u-custom-left-right-menu-spacing u-custom-padding-bottom u-custom-top-bottom-menu-spacing u-nav-link u-text-active-palette-1-base u-text-hover-palette-2-base" href="#">
            <svg class="u-svg-link" viewBox="0 0 24 24"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#menu-hamburger"></use></svg>
            <svg class="u-svg-content" version="1.1" id="menu-hamburger" viewBox="0 0 16 16" x="0px" y="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"><g><rect y="1" width="16" height="2"></rect><rect y="7" width="16" height="2"></rect><rect y="13" width="16" height="2"></rect>
</g></svg>
          </a>
        </div>
        <div class="u-custom-menu u-nav-container">
          <ul class="u-custom-font u-nav u-unstyled u-nav-1"><li class="u-nav-item"><a class="u-button-style u-nav-link u-text-active-palette-1-base u-text-hover-palette-2-base" href="https://anewday.co.th" style="padding: 10px 20px;">Home</a>
</li><li class="u-nav-item"><a class="u-button-style u-nav-link u-text-active-palette-1-base u-text-hover-palette-2-base" href="https://anewday.co.th/en/shop/" style="padding: 10px 20px;">Products</a>
</li></ul>
        </div>
        <div class="u-custom-menu u-nav-container-collapse">
          <div class="u-black u-container-style u-inner-container-layout u-opacity u-opacity-95 u-sidenav">
            <div class="u-inner-container-layout u-sidenav-overflow">
              <div class="u-menu-close"></div>
              <ul class="u-align-center u-nav u-popupmenu-items u-unstyled u-nav-2"><li class="u-nav-item"><a class="u-button-style u-nav-link" href="https://anewday.co.th">Home</a>
</li><li class="u-nav-item"><a class="u-button-style u-nav-link" href="https://anewday.co.th/en/shop/">Products</a>
</li></ul>
            </div>
          </div>
          <div class="u-black u-menu-overlay u-opacity u-opacity-70"></div>
        </div>
      </nav></header>
    <section class="u-align-center u-clearfix u-image u-shading u-section-1" src="" data-image-width="1920" data-image-height="775" id="sec-aa94">
      <div class="u-clearfix u-sheet u-valign-middle-xs u-sheet-1">
        <h1 class="u-custom-font u-text u-title u-text-1">Online Warranty<br>&nbsp;Registration
        </h1>
        <p class="u-custom-font u-large-text u-text u-text-variant u-text-2"> กรุณาลงทะเบียนการรับประกันสินค้า<br>เพื่อประโยชน์ในการรับบริการในอนาคต
        </p>
        <a href="https://warranty.anewday.co.th/warranty-condition-th" class="u-btn u-button-style u-custom-font u-palette-2-base u-btn-1" style="background-color:#f29802 !important">Read More</a>
      </div>
    </section>
    <section class="u-border-2 u-border-grey-10 u-border-no-left u-border-no-right u-border-no-top u-clearfix u-section-2" id="sec-412b">
      <div class="u-clearfix u-sheet u-sheet-1">
        <h3 class="u-align-center u-text u-text-1">คุณกำลังลงทะเบียนรับประกันสินค้าด้วย QR Code</h3>
        <div class="px-8 mt-5">
          <div v-if="isUsed.visible" class="bg-red-100 rounded-lg py-5 px-6 text-base text-red-700 inline-flex items-center w-full" role="alert">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="times-circle" class="w-4 h-4 mr-2 fill-current" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path fill="currentColor" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"></path>
            </svg>
            {{isUsed.message}}
          </div>
        </div>
        <div class="u-expanded-width-md u-expanded-width-sm u-expanded-width-xs u-list u-list-1">
          <div class="u-repeater u-repeater-1">
            <div class="u-container-style u-list-item u-repeater-item u-white u-list-item-1">
              <div class="u-container-layout u-similar-container u-container-layout-1">
                <img alt="" class="u-border-1 u-border-palette-5-light-2 u-image u-image-default u-image-1" data-image-width="195" data-image-height="190" src="../../../assets/warranty-images/qr1.png">
                <h3 class="u-align-center u-text u-text-2"> หมายเลขสินค้า<br>Serial Number
                </h3>
                <p class="u-align-center u-custom-font u-text u-text-3">{{lot_no}}</p>
              </div>
            </div>
            <div class="u-container-style u-list-item u-repeater-item u-white u-list-item-2">
              <div class="u-container-layout u-similar-container u-container-layout-2">
                <img alt="" class="u-border-1 u-border-palette-5-light-2 u-image u-image-default u-image-2" data-image-width="768" data-image-height="768" :src="resolveProductImage(path_img_product)">
                <h3 class="u-align-center u-text u-text-4"> ชื่อสินค้า<br>Product Name
                </h3>
                <p class="u-align-center u-custom-font u-text u-text-5">{{product_name}}</p>
              </div>
            </div>
            <div class="u-align-center u-container-style u-list-item u-repeater-item u-white u-list-item-3">
              <div class="u-container-layout u-similar-container u-container-layout-3">
                <img alt="" class="u-border-1 u-border-palette-5-light-2 u-image u-image-contain u-image-default u-image-3" data-image-width="155" data-image-height="74" src="../../../assets/warranty-images/img-brand-blackhole.webp">
                <h3 class="u-align-center u-text u-text-6"> ยี่ห้อ<br>Brand
                </h3>
                <p class="u-align-center u-custom-font u-text u-text-7">{{product_brand}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="u-clearfix u-section-3" id="sec-be2d">
      <div class="u-clearfix u-sheet u-sheet-1">
        <div class="u-clearfix u-expanded-width u-gutter-0 u-layout-wrap u-layout-wrap-1">
          <div class="u-gutter-0 u-layout">
            <div class="u-layout-col">
              <div class="u-align-center u-container-style u-layout-cell u-radius-20 u-size-60 u-layout-cell-1">
                <div class="u-container-layout u-container-layout-1">
                  <h3 class="u-text u-text-1">กรุณากรอกข้อมูลติดต่อ</h3>
                  <div class="u-form u-form-1">
                    <form action="https://forms.nicepagesrv.com/Form/Process" class="u-clearfix u-form-spacing-5 u-form-vertical u-inner-form" style="padding: 0;" source="email" name="form">
                      <div class="u-form-group u-form-name u-label-top">
                        <label for="name-daf4" class="u-custom-font u-label u-label-1">ชื่อ-นามสกุล / Full Name : <span style="color:red">*</span></label>
                        <input v-model.trim="form.fullname" @change="fullnameRules" placeholder="Enter your name" type="text" id="name-daf4" name="name" class="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-custom-font u-input u-input-rectangle u-white u-input-1" required="required">
                      </div>
                      <div class="u-form-address u-form-group u-label-top u-form-group-2">
                        <label for="address-36e2" class="u-custom-font u-label u-label-2">ที่อยู่ / Address : <span style="color:red">*</span></label>
                        <input v-model.trim="form.address" @change="addressRules" type="text" placeholder="Enter your address" id="address-36e2" name="address" class="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-custom-font u-input u-input-rectangle u-white u-input-2" required="">
                      </div>
                      <div class="u-form-address u-form-group u-label-top u-form-group-3">
                        <label class="u-custom-font u-label u-label-3">จังหวัด / Province : <span style="color:red">*</span></label>
                        <thai-address-input type="province"
                            v-model="province"
                            placeholder="Enter province"
                            style="font-family:'Kanit'"
                            :input-class="`u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-custom-font u-input u-input-rectangle u-white u-input-3 ${rules.province.alert}`" @change="provinceRules"
                            @selected="onSelected">
                        </thai-address-input>
                      </div>
                      <div class="u-form-address u-form-group u-label-top u-form-group-4">
                        <label class="u-custom-font u-label u-label-4">แขวง (ตำบล) / Sub District : <span style="color:red">*</span></label>
                        <thai-address-input type="subdistrict"
                            v-model="subdistrict"
                            placeholder="Enter sub district"
                            style="font-family:'Kanit'"
                            :input-class="`u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-custom-font u-input u-input-rectangle u-white u-input-4 ${rules.subdistrict.alert}`" @change="subdistrictRules"
                            @selected="onSelected">
                        </thai-address-input>
                      </div>
                      <div class="u-form-address u-form-group u-label-top u-form-group-5">
                        <label class="u-custom-font u-label u-label-5">เขต (อำเภอ) / District : <span style="color:red">*</span></label>
                        <thai-address-input type="district"
                            v-model="district"
                            placeholder="Enter district"
                            style="font-family:'Kanit'"
                            :input-class="`u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-custom-font u-input u-input-rectangle u-white u-input-5 ${rules.district.alert}`" @change="districtRules"
                            @selected="onSelected">
                        </thai-address-input>
                      </div>
                      <div class="u-form-address u-form-group u-label-top u-form-group-6">
                        <label for="address-f8f4" class="u-custom-font u-label u-label-6">รหัสไปรษณีย์ / Zipcode : <span style="color:red">*</span></label>
                        <thai-address-input type="postalCode"
                            v-model="postalCode"
                            placeholder="Enter zipcode"
                            style="font-family:'Kanit'"
                            :input-class="`u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-custom-font u-input u-input-rectangle u-white u-input-6 ${rules.postalCode.alert}`" @change="postalCodeRules"
                            @selected="onSelected">
                        </thai-address-input>
                      </div>
                      <div class="u-form-group u-form-phone u-label-top u-form-group-7">
                        <label for="phone-bdf7" class="u-custom-font u-label u-label-7">เบอร์โทรศัพท์ / Phone : <span style="color:red">*</span> <span style="color:#999;font-size:0.85rem;font-weight:normal">(ไม่ต้องใส่ -)</span></label>
                        <input v-model.trim="form.phone" @change="phoneRules" @input="form.phone = form.phone.replace(/[^0-9]/g, '')" placeholder="Enter your phone number" type="tel" maxlength="10" id="phone-bdf7" name="phone" class="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-custom-font u-input u-input-rectangle u-white u-input-7" required="">
                      </div>
                      <div class="u-form-email u-form-group u-label-top">
                        <label for="email-daf4" class="u-custom-font u-label u-label-8">อีเมล / Email : <span style="color:red">*</span></label>
                        <input v-model.trim="form.email" @change="emailRules" type="email" placeholder="Enter a valid email address" id="email-daf4" name="email" class="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-custom-font u-input u-input-rectangle u-white u-input-8" required="">
                      </div>
                      <!-- New fields ตาม Mock up -->
                      <div class="u-form-group u-label-top" style="margin-left:0">
                        <label class="u-custom-font u-label" style="font-size:1.125rem;font-family:Kanit">ช่องทางการซื้อ / Purchasing Channel : <span style="color:red">*</span></label>
                        <select v-model="form.dealer_id" class="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-custom-font u-input u-input-rectangle u-white" style="font-family:Kanit;width:100%;height:42px" required>
                          <option value="" disabled>-- เลือกช่องทางการซื้อ --</option>
                          <option v-for="d in dealers" :key="d.id" :value="d.id">{{ d.name }}</option>
                          <!-- <option value="other">อื่นๆ / Other</option> -->
                        </select>
                      </div>
                      <!--
                      <div v-if="form.dealer_id === 'other'" class="u-form-group u-label-top" style="margin-left:0">
                        <label class="u-custom-font u-label" style="font-size:1.125rem;font-family:Kanit">ระบุช่องทางการซื้อ : <span style="color:red">*</span></label>
                        <input v-model.trim="form.dealer_other" type="text" placeholder="กรอกชื่อช่องทางการซื้อ" class="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-custom-font u-input u-input-rectangle u-white" style="font-family:Kanit" required />
                      </div>
                      -->
                      <div class="u-form-group u-label-top" style="margin-left:0">
                        <label class="u-custom-font u-label" style="font-size:1.125rem;font-family:Kanit">วันที่ซื้อ / Date of Purchase (DOP) : <span style="color:red">*</span></label>
                        <input v-model="form.purchase_date" type="date" :max="todayISO" class="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-custom-font u-input u-input-rectangle u-white" style="font-family:Kanit" required />
                      </div>
                      <div class="u-form-group u-label-top" style="margin-left:0">
                        <label class="u-custom-font u-label" style="font-size:1.125rem;font-family:Kanit">เลขที่ใบเสร็จ / Receipt No. : <span style="color:red">*</span></label>
                        <input v-model.trim="form.receipt_number" type="text" placeholder="INVxxxxxx" class="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-custom-font u-input u-input-rectangle u-white" style="font-family:Kanit" required />
                      </div>
                      <div class="u-form-group u-label-top" style="margin-left:0">
                        <label class="u-custom-font u-label" style="font-size:1.125rem;font-family:Kanit">Box No. : <span style="color:red">*</span></label>
                        <input v-model.trim="form.box_no" type="text" placeholder="เลข S/N บนกล่อง ถ้าไม่มีใส่ -" class="u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-custom-font u-input u-input-rectangle u-white" style="font-family:Kanit" required />
                      </div>
                      <!-- End new fields -->

                      <div class="u-form-email u-form-group u-label-top">
                        <label for="email-daf4" class="u-custom-font u-label u-label-8">แนบใบเสร็จ : <span style="color:red">*</span></label>
                        <input class="u-custom-font u-input u-input-rectangle u-white u-input-8" type="file" accept="image/jpeg,image/png" @change="uploadImage" required>
                        <img v-if="previewImage" :src="previewImage" class="uploading-image px-8 py-8 flex jusity-center u-border-2 u-border-black u-border-no-left u-border-no-right u-border-no-top u-custom-font u-input u-input-rectangle u-white u-input-8" />
                      </div>

                      <!-- Consent #1 — บังคับ (เงื่อนไขรับประกัน) -->
                      <div class="u-form-agree u-form-group u-label-top u-form-group-9 mt-5">
                        <input type="checkbox" v-model="consent" name="agree" class="u-agree-checkbox mr-3" required="">
                        <label class="u-agree-label u-custom-font u-label u-label-9">ข้าพเจ้ายอมรับ <a target="_blank" href="https://anewday.co.th/privacy-policy/">นโยบายความเป็นส่วนตัว</a> และ <a target="_blank" href="https://warranty.anewday.co.th/warranty-condition-th">เงื่อนไขการรับประกัน</a> <br> I accept the <a target="_blank" href="https://anewday.co.th/privacy-policy/">Terms of Service</a> and <a target="_blank" href="https://warranty.anewday.co.th/warranty-condition-en">Warranty Terms </a>
                        </label>
                      </div>
                      <!-- Consent #2 — สมัครใจ (ชิงโชค+การตลาด) -->
                      <div class="u-form-agree u-form-group u-label-top mt-3" style="margin-left:0">
                        <input type="checkbox" v-model="consent_marketing" name="agree_marketing" class="u-agree-checkbox mr-3">
                        <label class="u-agree-label u-custom-font u-label u-label-9">ข้าพเจ้ายินยอมให้บริษัทเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของข้าพเจ้า เพื่อวัตถุประสงค์ในการแจ้งข้อมูลข่าวสาร โปรโมชัน และการเข้าร่วมกิจกรรมชิงโชครางวัลต่างๆ
                        </label>
                      </div>
      
                      <!--<div class="u-form-send-message u-form-send-success"> Thank you! Your message has been sent. </div>
                      <div class="u-form-send-error u-form-send-message"> Unable to send your message. Please fix errors then try again. </div>
                      <input type="hidden" value="" name="recaptchaResponse">
                      <input type="hidden" name="formServices" value="af701f742902726c4e31c4976c327488">-->
                    </form>
                    <!-- reCAPTCHA Enterprise (invisible v3 style) — ไม่ต้องแสดง checkbox -->
                    <!-- captcha token จะถูกสร้างอัตโนมัติตอน submit -->
                    <div class="u-align-left u-form-group u-form-submit u-label-top" >
                      <a  @click="submit" style="background-color:#f29802 !important"  href="#" class="u-active-palette-1-light-2 u-border-none u-btn u-btn-round u-btn-submit u-button-style u-custom-font u-hover-palette-1-light-1 u-palette-1-base u-radius-12 u-btn-1">Submit</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
    
    <footer class="u-clearfix u-footer u-grey-80" id="sec-3f03"><div class="u-clearfix u-sheet u-sheet-1">
        <div class="u-align-left u-social-icons u-spacing-10 u-social-icons-1">
          <a class="u-social-url" target="_blank" data-type="Custom" title="Line" href="https://line.me/R/ti/p/%40blackholethailand"><span class="u-file-icon u-icon u-social-custom u-social-icon u-icon-1"><img src="../../../assets/warranty-images/3670089.png" alt=""></span>
          </a>
          <a class="u-social-url" title="facebook" target="_blank" href="https://www.facebook.com/blackholethailand/"><span class="u-icon u-social-facebook u-social-icon u-icon-2"><svg class="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 112 112" style=""><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-5e5c"></use></svg><svg class="u-svg-content" viewBox="0 0 112 112" x="0" y="0" id="svg-5e5c"><circle fill="currentColor" cx="56.1" cy="56.1" r="55"></circle><path fill="#FFFFFF" d="M73.5,31.6h-9.1c-1.4,0-3.6,0.8-3.6,3.9v8.5h12.6L72,58.3H60.8v40.8H43.9V58.3h-8V43.9h8v-9.2
            c0-6.7,3.1-17,17-17h12.5v13.9H73.5z"></path></svg></span>
          </a>
          <a class="u-social-url" title="instagram" target="_blank" href="https://www.instagram.com/blackholethailand/"><span class="u-icon u-social-icon u-social-instagram u-icon-3"><svg class="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 112 112" style=""><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-4e65"></use></svg><svg class="u-svg-content" viewBox="0 0 112 112" x="0" y="0" id="svg-4e65"><circle fill="currentColor" cx="56.1" cy="56.1" r="55"></circle><path fill="#FFFFFF" d="M55.9,38.2c-9.9,0-17.9,8-17.9,17.9C38,66,46,74,55.9,74c9.9,0,17.9-8,17.9-17.9C73.8,46.2,65.8,38.2,55.9,38.2
            z M55.9,66.4c-5.7,0-10.3-4.6-10.3-10.3c-0.1-5.7,4.6-10.3,10.3-10.3c5.7,0,10.3,4.6,10.3,10.3C66.2,61.8,61.6,66.4,55.9,66.4z"></path><path fill="#FFFFFF" d="M74.3,33.5c-2.3,0-4.2,1.9-4.2,4.2s1.9,4.2,4.2,4.2s4.2-1.9,4.2-4.2S76.6,33.5,74.3,33.5z"></path><path fill="#FFFFFF" d="M73.1,21.3H38.6c-9.7,0-17.5,7.9-17.5,17.5v34.5c0,9.7,7.9,17.6,17.5,17.6h34.5c9.7,0,17.5-7.9,17.5-17.5V38.8
            C90.6,29.1,82.7,21.3,73.1,21.3z M83,73.3c0,5.5-4.5,9.9-9.9,9.9H38.6c-5.5,0-9.9-4.5-9.9-9.9V38.8c0-5.5,4.5-9.9,9.9-9.9h34.5
            c5.5,0,9.9,4.5,9.9,9.9V73.3z"></path></svg></span>
          </a>
          <a class="u-social-url" title="twitter" target="_blank" href="https://twitter.com/blackholeTH2017"><span class="u-icon u-social-icon u-social-twitter u-icon-4"><svg class="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 112 112" style=""><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-e7f2"></use></svg><svg class="u-svg-content" viewBox="0 0 112 112" x="0" y="0" id="svg-e7f2"><circle fill="currentColor" class="st0" cx="56.1" cy="56.1" r="55"></circle><path fill="#FFFFFF" d="M83.8,47.3c0,0.6,0,1.2,0,1.7c0,17.7-13.5,38.2-38.2,38.2C38,87.2,31,85,25,81.2c1,0.1,2.1,0.2,3.2,0.2
            c6.3,0,12.1-2.1,16.7-5.7c-5.9-0.1-10.8-4-12.5-9.3c0.8,0.2,1.7,0.2,2.5,0.2c1.2,0,2.4-0.2,3.5-0.5c-6.1-1.2-10.8-6.7-10.8-13.1
            c0-0.1,0-0.1,0-0.2c1.8,1,3.9,1.6,6.1,1.7c-3.6-2.4-6-6.5-6-11.2c0-2.5,0.7-4.8,1.8-6.7c6.6,8.1,16.5,13.5,27.6,14
            c-0.2-1-0.3-2-0.3-3.1c0-7.4,6-13.4,13.4-13.4c3.9,0,7.3,1.6,9.8,4.2c3.1-0.6,5.9-1.7,8.5-3.3c-1,3.1-3.1,5.8-5.9,7.4
            c2.7-0.3,5.3-1,7.7-2.1C88.7,43,86.4,45.4,83.8,47.3z"></path></svg></span>
          </a>
          <a class="u-social-url" target="_blank" data-type="YouTube" title="YouTube" href="https://www.youtube.com/channel/UC5her_rmFbYJ_NtPL2AypvQ"><span class="u-icon u-social-icon u-social-youtube u-icon-5"><svg class="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 112 112" style=""><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-b8fd"></use></svg><svg class="u-svg-content" viewBox="0 0 112 112" x="0" y="0" id="svg-b8fd"><circle fill="currentColor" cx="56.1" cy="56.1" r="55"></circle><path fill="#FFFFFF" d="M74.9,33.3H37.3c-7.4,0-13.4,6-13.4,13.4v18.8c0,7.4,6,13.4,13.4,13.4h37.6c7.4,0,13.4-6,13.4-13.4V46.7 C88.3,39.3,82.3,33.3,74.9,33.3L74.9,33.3z M65.9,57l-17.6,8.4c-0.5,0.2-1-0.1-1-0.6V47.5c0-0.5,0.6-0.9,1-0.6l17.6,8.9 C66.4,56,66.4,56.8,65.9,57L65.9,57z"></path></svg></span>
          </a>
        </div>
        <div class="u-expanded-width u-layout-grid u-list u-list-1">
          <div class="u-repeater u-repeater-1">
            <div class="u-align-left u-container-style u-custom-color-1 u-list-item u-radius-20 u-repeater-item u-shape-round u-list-item-1" data-animation-name="bounceIn" data-animation-duration="1500" data-animation-direction="Right" data-animation-delay="500">
              <div class="u-container-layout u-similar-container u-container-layout-1">
                <h5 class="u-custom-font u-text u-text-1"><span class="u-file-icon u-icon u-text-white"><img src="images/597177-de35359a.png" alt=""></span>&nbsp;Call Us
                </h5>
                <p class="u-text u-text-2">
                  <a class="u-active-none u-border-none u-btn u-button-link u-button-style u-hover-none u-none u-text-hover-palette-1-base u-text-white u-btn-1" href="tel:02-725-0841"> 02-725-0841</a>
                </p>
              </div>
            </div>
            <div class="u-align-left u-container-style u-custom-color-1 u-list-item u-radius-20 u-repeater-item u-shape-round u-list-item-2" data-animation-name="bounceIn" data-animation-duration="1500" data-animation-direction="Right" data-animation-delay="500">
              <div class="u-container-layout u-similar-container u-container-layout-2">
                <h5 class="u-custom-font u-text u-text-3"><span class="u-file-icon u-icon"><img src="../../../assets/warranty-images/email-icons-white-color-958812.jpg" alt=""></span>&nbsp;Email
                </h5>
                <p class="u-custom-font u-text u-text-4">
                  <a class="u-active-none u-border-none u-btn u-button-link u-button-style u-hover-none u-none u-text-hover-palette-1-base u-text-white u-btn-2" href="mailto:online@anewday.co.th"> online@anewday.co.th</a>
                </p>
              </div>
            </div>
            <div class="u-align-left u-container-style u-custom-color-1 u-list-item u-radius-20 u-repeater-item u-shape-round u-list-item-3" data-animation-name="bounceIn" data-animation-duration="1500" data-animation-direction="Right" data-animation-delay="500">
              <div class="u-container-layout u-similar-container u-container-layout-3">
                <h5 class="u-custom-font u-text u-text-5"><span class="u-file-icon u-icon u-text-white"><img src="../../../assets/warranty-images/484167-0f572cc8.png" alt=""></span> A New Day Co.,Ltd 
                </h5>
                <p class="u-custom-font u-text u-text-6">
                  <a class="u-active-none u-border-none u-btn u-button-link u-button-style u-hover-none u-none u-text-hover-palette-1-base u-text-white u-btn-3" href="https://www.google.com/maps?ll=13.775506,100.596097&amp;z=20&amp;t=m&amp;hl=en&amp;gl=TH&amp;mapclient=embed&amp;cid=6701663887302958155"> 634/4 Soi. Ramkhamheang 39 ( Theplila 1 ), Phachautit Rd., Wangthonglang, Bangkok 10310 Thailand </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div></footer>
    <!--<section class="u-backlink u-clearfix u-grey-80">
      <a class="u-link" href="https://nicepage.com/website-templates" target="_blank">
        <span>Website Templates</span>
      </a>
      <p class="u-text">
        <span>created with</span>
      </p>
      <a class="u-link" href="" target="_blank">
        <span>Website Builder Software</span>
      </a>. 
    </section><span style="height: 64px; width: 64px; margin-left: 0px; margin-right: auto; margin-top: 0px; background-image: none; right: 20px; bottom: 20px; padding: 15px;" class="u-back-to-top u-icon u-icon-circle u-opacity u-opacity-85 u-palette-1-base" data-href="#">
        <svg class="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 551.13 551.13"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-1d98"></use></svg>
        <svg class="u-svg-content" enable-background="new 0 0 551.13 551.13" viewBox="0 0 551.13 551.13" xmlns="http://www.w3.org/2000/svg" id="svg-1d98"><path d="m275.565 189.451 223.897 223.897h51.668l-275.565-275.565-275.565 275.565h51.668z"></path></svg>
    </span>-->
  
</body>
</template>

<script src="https://unpkg.com/vue-recaptcha@latest/dist/vue-recaptcha.js"></script>
<!-- Minify -->
<script src="https://unpkg.com/vue-recaptcha@latest/dist/vue-recaptcha.min.js"></script>
<script src="https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit" async defer>
</script>
<script charset="utf-8" src="https://static.line-scdn.net/liff/edge/2/sdk.js"></script><script>
import axios from 'axios'
export default {
  created(){
    document.title = "A New Day Warranty"
  }, 
  components: {
  },
  name: 'registerFrom',
  data() {
    return {
      recaptchaSiteKey: '6LeI2_srAAAAALWAMGXYZPjuPMUizW6IqAt7xN_9',
      // default path image 
      path_img_product : "RBSOVEN70LM2.png",

      // address api
      subdistrict: '',
      district: '',
      province: '',
      postalCode: '',
      search: '',
      searchResult: '',

      // lot product
      products: [],
      lot_no : '',
      product_name: '',
      product_code: '',
      product_brand: '',

      previewImage:null,
      
      captcha : null,
      showPassword: false,
      loading: false,
      validForm: false,
      consent: false,
      consent_marketing: false,
      consents: [],
      result_consents : [],
      form: {
        fullname: '',
        address: '',
        phone:'',
        email: '',
        dealer_id: '',
        dealer_other: '',
        purchase_date: '',
        receipt_number: '',
        box_no: '',
      },
      dealers: [],
      userLineInfo: null,
      isUsed: {
        visible: false,
        message: 'บางอย่างผิดพลาดกรุณาลองใหม่อีกครั้ง'
      },
      ispdpa: {
        visible: false,
        message: 'บางอย่างผิดพลาดกรุณาลองใหม่อีกครั้ง'
      },
      rules: {
        fullname: {
          msg: 'ไม่สามารถเว้นว่างได้',
          visible: false,
          alert: ''
        },
        address: {
          msg: 'ไม่สามารถเว้นว่างได้',
          visible: false,
          alert: ''
        },
        province: {
          msg: 'ไม่สามารถเว้นว่างได้',
          visible: false,
          alert: ''
        },
        subdistrict: {
          msg: 'ไม่สามารถเว้นว่างได้',
          visible: false,
          alert: ''
        },
        district: {
          msg: 'ไม่สามารถเว้นว่างได้',
          visible: false,
          alert: ''
        },
        postalCode: {
          msg: 'ไม่สามารถเว้นว่างได้',
          visible: false,
          alert: ''
        },
        email: {
          msg: 'ไม่สามารถเว้นว่างได้',
          visible: false,
          alert: ''
        },
        phone: {
          msg: '',
          visible: false,
          alert: ''
        },
        confirmPassword: {
          msg: 'รหัสผ่านไม่ตรงกัน',
          visible: false,
          alert: ''
        },
        consent: {
          msg: 'ต้องได้รับความยินยอมความเป็นส่วนตัวก่อน',
          visible: false,
          alert: ''
        }
      },

    }
  },
  async mounted() {
    await this.loadRecaptchaEnterprise()
    await this.getDealers()
    await this.getLot()
  },
  computed: {
    todayISO() {
      return new Date().toISOString().split('T')[0]
    }
  },
  methods: {
    resolveProductImage(fileName) {
      const defaultImage = require('@/assets/warranty-images/RBSOVEN70LM2.png')
      if (!fileName) return defaultImage

      try {
        return require(`@/assets/warranty-images/${fileName}`)
      } catch (e) {
        return defaultImage
      }
    },

    async loadRecaptchaEnterprise() {
      return new Promise((resolve) => {
        if (window.grecaptcha && window.grecaptcha.enterprise) { resolve(); return }
        const s = document.createElement('script')
        s.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.recaptchaSiteKey}`
        s.onload = () => {
          window.grecaptcha.enterprise.ready(() => resolve())
        }
        s.onerror = () => resolve() // ไม่ block ถ้าโหลดไม่ได้
        document.head.appendChild(s)
      })
    },

    async getRecaptchaToken() {
      try {
        if (window.grecaptcha && window.grecaptcha.enterprise) {
          return await window.grecaptcha.enterprise.execute(this.recaptchaSiteKey, { action: 'warranty_register' })
        }
      } catch (e) {
        console.error('reCAPTCHA error:', e)
      }
      return null
    },

    async getDealers() {
      try {
        await axios({
          method: 'post',
          url: `${process.env.VUE_APP_API}/anewday_get_sale_channels`,
          data: {}
        })
        .then((res) => {
          if (res.data.resCode == "00") {
            this.dealers = res.data.resData
          }
        })
      } catch (error) {
        console.error('Get dealers error:', error)
      }
    },

    async getLot(){
      if(this.$route.params.lot_no){
        localStorage.setItem('ANEWDAY_LOT', this.$route.params.lot_no)
        await axios({
          method: 'post',
          url: `${process.env.VUE_APP_API}/anewday_get_lot_product`,
          data: {
            lot_no: this.$route.params.lot_no,
          }
        })
        .then((res) => {
          if (res.data.resCode == "00"){
            this.products = res.data.resData
            this.lot_no = res.data.resData[0]['lot']
            this.product_name = res.data.resData[0]['name']
            this.product_code = res.data.resData[0]['code']
            this.product_brand = res.data.resData[0]['brand']
            this.path_img_product = res.data.resData[0]['path_img_product']
          }else if(res.data.resCode == "02"){// already regiseter
            this.$router.push({path: '/warranty-success'})
          }else{ // 01 = error
            this.isUsed.message = res.data.resDesc
            this.isUsed.visible = true
          }
        })
      }
    },

    uploadImage(e){
      const image = e.target.files[0];
      if (!image) {
        this.previewImage = null
        return
      }
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = e =>{
        this.previewImage = e.target.result;
      };
    },

    delete_img(){
      this.previewImage = null
    },

    onSelected(address) {
      this.subdistrict = address.subdistrict;
      this.district = address.district;
      this.province = address.province;
      this.postalCode = address.postalCode;
    },
    onSearched(address) {
      this.searchResult = address;
    },

    async submit() {
      this.loading = true

      this.checkValidInput()
      if (!this.validForm) {
        return null
      }

      // reCAPTCHA Enterprise — get token อัตโนมัติ
      let recaptchaToken = null
      try {
        recaptchaToken = await this.getRecaptchaToken()
      } catch (e) {
        console.warn('reCAPTCHA error:', e)
      }

      // consent
      if (this.consent == false){
        this.isUsed.visible = true
        this.isUsed.message = 'โปรดยอมรับนโยบายความเป็นส่วนตัวและเงื่อนไขการรับประกัน'
        setTimeout(() => {
          this.isUsed.visible = false,
          this.isUsed.message = 'err msg'
        }, 5000)
        return null
      }
      try {
        await axios({
          method: 'post',
          url: `${process.env.VUE_APP_API}/anewday_warranty_register`,
          data: {
            name: this.form.fullname,
            address: this.form.address,
            phone: this.form.phone,
            email: this.form.email,
            subdistrict: this.subdistrict,
            district: this.district,
            province: this.province, 
            postalCode: this.postalCode,
            products: this.products,
            image: this.previewImage,
            dealer_id: this.form.dealer_id === 'other' ? false : this.form.dealer_id,
            dealer: this.form.dealer_id === 'other' ? this.form.dealer_other : '',
            purchase_date: this.form.purchase_date,
            receipt_number: this.form.receipt_number,
            box_no: this.form.box_no,
            consent_warranty: this.consent,
            consent_marketing: this.consent_marketing,
            recaptcha_token: recaptchaToken,
          }
        })
        .then((res) => {
          if (res.data.resCode == "00"){
            this.$router.push({path: '/warranty-success'}) // user-home
          }else{ // 01 = error
            this.isUsed.message = res.data.resDesc
            this.isUsed.visible = true
          }
        })
      } catch (error) {
        this.isUsed.visible = true
        if (error?.response?.data?.message) {
          this.isUsed.message = error.response.data.message
        } else {
          this.isUsed.message = 'บางอย่างผิดพลาดกรุณาลองใหม่อีกครั้ง'
        }

        setTimeout(() => {
          this.isUsed.visible = false,
          this.isUsed.message = ''
          }, 5000)

      }

    },
    fullnameRules() {
      if (this.form.fullname === "") {
        this.rules.fullname.visible = true
        this.rules.fullname.alert = 'rules-alert'
        this.validForm = false

        setTimeout(() => {
          this.rules.fullname.visible = false
          this.rules.fullname.alert = ''
        }, 5000)

      } else {
        this.rules.fullname.visible = false
        this.rules.fullname.alert = ''
      }
    },

    addressRules() {
      if (this.form.address === "") {
        this.rules.address.visible = true
        this.rules.address.alert = 'rules-alert'
        this.validForm = false

        setTimeout(() => {
          this.rules.address.visible = false
          this.rules.address.alert = ''
        }, 5000)

      } else {
        this.rules.address.visible = false
        this.rules.address.alert = ''
      }
    },

    subdistrictRules(){
      if (this.subdistrict === "") {
        this.rules.subdistrict.visible = true
        this.rules.subdistrict.alert = 'rules-alert'
        this.validForm = false

        setTimeout(() => {
          this.rules.subdistrict.visible = false
          this.rules.subdistrict.alert = ''
        }, 5000)

      } else {
        this.rules.subdistrict.visible = false
        this.rules.subdistrict.alert = ''
      }
    },

    districtRules(){
      if (this.district === "") {
        this.rules.district.visible = true
        this.rules.district.alert = 'rules-alert'
        this.validForm = false

        setTimeout(() => {
          this.rules.district.visible = false
          this.rules.district.alert = ''
        }, 5000)

      } else {
        this.rules.district.visible = false
        this.rules.district.alert = ''
      }
    },

    provinceRules(){
      if (this.province === "") {
        this.rules.province.visible = true
        this.rules.province.alert = 'rules-alert'
        this.validForm = false

        setTimeout(() => {
          this.rules.province.visible = false
          this.rules.province.alert = ''
        }, 5000)

      } else {
        this.rules.province.visible = false
        this.rules.province.alert = ''
      }
    },

    postalCodeRules(){
      if (this.postalCode === "") {
        this.rules.postalCode.visible = true
        this.rules.postalCode.alert = 'rules-alert'
        this.validForm = false

        setTimeout(() => {
          this.rules.postalCode.visible = false
          this.rules.postalCode.alert = ''
        }, 5000)

      } else {
        this.rules.postalCode.visible = false
        this.rules.postalCode.alert = ''
      }
    },

    phoneRules(){
      if (this.form.phone.length !== 10) {
        this.rules.phone.visible = true
        this.rules.phone.msg = 'กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง'
        this.rules.phone.alert = 'rules-alert'
        this.validForm = false
        return null
      }

      const isTelNumber = /[0]{1}[0-9]{9}/.test(this.form.phone)

      if (!isTelNumber) {
        this.rules.phone.visible = true
        this.rules.phone.msg = 'กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง'
        this.rules.phone.alert = 'rules-alert'
        this.validForm = false
        return null
      }

      if (isTelNumber) {
        this.rules.phone.visible = false
        this.rules.phone.alert = ''

      }
    },

    emailRules() {
      const isEmail = /.+@.+[.]+./.test(this.form.email)

      if (!isEmail) {
        this.rules.email.visible = true
        this.rules.email.msg = 'กรุณากรอกอีเมลให้ถูกต้อง'
        this.rules.email.alert = 'rules-alert'
        this.validForm = false
        return null
      }

      if (isEmail) {
        this.rules.email.visible = false
        this.rules.email.alert = ''

      }

    },
    checkValidInput() {
      this.validForm = false  // reset ก่อน

      if (this.form.fullname === '') {
        this.isUsed.visible = true
        this.isUsed.message = 'ชื่อ - สกุล ไม่สามารถเว้นว่างได้'
        setTimeout(() => {
          this.isUsed.visible = false,
          this.isUsed.message = 'err msg'
        }, 5000)
        return null

        /*this.rules.fullname.visible = true
        this.rules.fullname.alert = 'rules-alert'
        this.rules.fullname.msg = 'ชื่อ - สกุล ไม่สามารถเว้นว่างได้'
        this.validForm = false
        setTimeout(() => {
          this.rules.fullname.visible = false
          this.rules.fullname.alert = ''
        }, 3000)*/
      }

      else if (this.form.address === '') {
        this.isUsed.visible = true
        this.isUsed.message = 'ที่อยู่ไม่สามารถเว้นว่างได้'
        setTimeout(() => {
          this.isUsed.visible = false,
          this.isUsed.message = 'err msg'
        }, 5000)
        return null

        /*this.rules.address.visible = true
        this.rules.address.alert = 'rules-alert'
        this.rules.address.msg = 'ที่อยู่ไม่สามารถเว้นว่างได้'
        this.validForm = false
        setTimeout(() => {
          this.rules.address.visible = false
          this.rules.address.alert = ''
        }, 3000)*/
      }

      else if (this.subdistrict === '') {
        this.isUsed.visible = true
        this.isUsed.message = 'แขวง(ตำบล)ไม่สามารถเว้นว่างได้'
        setTimeout(() => {
          this.isUsed.visible = false,
          this.isUsed.message = 'err msg'
        }, 5000)
        return null
        
        /*this.rules.subdistrict.visible = true
        this.rules.subdistrict.alert = 'rules-alert'
        this.rules.subdistrict.msg = 'แขวง(ตำบล)ไม่สามารถเว้นว่างได้'
        this.validForm = false
        setTimeout(() => {
          this.rules.subdistrict.visible = false
          this.rules.subdistrict.alert = ''
        }, 3000)*/
      }

      else if (this.district === '') {
        this.isUsed.visible = true
        this.isUsed.message = 'เขต(อำเภอ)ไม่สามารถเว้นว่างได้'
        setTimeout(() => {
          this.isUsed.visible = false,
          this.isUsed.message = 'err msg'
        }, 5000)
        return null

        /*this.rules.district.visible = true
        this.rules.district.alert = 'rules-alert'
        this.rules.district.msg = 'เขต(อำเภอ)ไม่สามารถเว้นว่างได้'
        this.validForm = false
        setTimeout(() => {
          this.rules.district.visible = false
          this.rules.district.alert = ''
        }, 3000)*/
      }

      else if (this.province === '') {
        this.isUsed.visible = true
        this.isUsed.message = 'จังหวัดไม่สามารถเว้นว่างได้'
        setTimeout(() => {
          this.isUsed.visible = false,
          this.isUsed.message = 'err msg'
        }, 5000)
        return null

        /*this.rules.province.visible = true
        this.rules.province.alert = 'rules-alert'
        this.rules.province.msg = 'จังหวัดไม่สามารถเว้นว่างได้'
        this.validForm = false
        setTimeout(() => {
          this.rules.province.visible = false
          this.rules.province.alert = ''
        }, 3000)*/
      }

      else if (this.postalCode === '') {
        this.isUsed.visible = true
        this.isUsed.message = 'รหัสไปรษณีย์ไม่สามารถเว้นว่างได้'
        setTimeout(() => {
          this.isUsed.visible = false,
          this.isUsed.message = 'err msg'
        }, 5000)
        return null

        /*this.rules.postalCode.visible = true
        this.rules.postalCode.alert = 'rules-alert'
        this.rules.postalCode.msg = 'รหัสไปรษณีย์ไม่สามารถเว้นว่างได้'
        this.validForm = false
        setTimeout(() => {
          this.rules.postalCode.visible = false
          this.rules.postalCode.alert = ''
        }, 3000)*/
      }

      else if (this.form.phone === '') {
        this.isUsed.visible = true
        this.isUsed.message = 'เบอร์โทรศัพท์ไม่สามารถเว้นว่างได้'
        setTimeout(() => {
          this.isUsed.visible = false,
          this.isUsed.message = 'err msg'
        }, 5000)
        return null

        /*this.rules.phone.visible = true
        this.rules.phone.alert = 'rules-alert'
        this.rules.phone.msg = 'เบอร์โทรศัพท์ไม่สามารถเว้นว่างได้'
        this.validForm = false
        setTimeout(() => {
          this.rules.phone.visible = false
          this.rules.phone.alert = ''
        }, 3000)*/
      }

      else if (this.form.email === '') {
        this.isUsed.visible = true
        this.isUsed.message = 'อีเมล์ไม่สามารถเว้นว่างได้'
        setTimeout(() => {
          this.isUsed.visible = false,
          this.isUsed.message = 'err msg'
        }, 5000)
        return null

        /*this.rules.email.visible = true
        this.rules.email.alert = 'rules-alert'
        this.rules.email.msg = 'อีเมล์ไม่สามารถเว้นว่างได้'
        this.validForm = false
        setTimeout(() => {
          this.rules.email.visible = false
          this.rules.email.alert = ''
        }, 3000)*/
      }
      else if (this.form.dealer_id === '') {
        this.isUsed.visible = true
        this.isUsed.message = 'กรุณาเลือกช่องทางการซื้อ'
        setTimeout(() => {
          this.isUsed.visible = false,
          this.isUsed.message = 'err msg'
        }, 5000)
        return null
      }

      else if (this.form.dealer_id === 'other' && this.form.dealer_other === '') {
        this.isUsed.visible = true
        this.isUsed.message = 'กรุณาระบุช่องทางการซื้อ'
        setTimeout(() => {
          this.isUsed.visible = false,
          this.isUsed.message = 'err msg'
        }, 5000)
        return null
      }

      else if (this.form.purchase_date === '') {
        this.isUsed.visible = true
        this.isUsed.message = 'วันที่ซื้อไม่สามารถเว้นว่างได้'
        setTimeout(() => {
          this.isUsed.visible = false,
          this.isUsed.message = 'err msg'
        }, 5000)
        return null
      }

      else if (this.form.receipt_number === '') {
        this.isUsed.visible = true
        this.isUsed.message = 'เลขที่ใบเสร็จไม่สามารถเว้นว่างได้'
        setTimeout(() => {
          this.isUsed.visible = false,
          this.isUsed.message = 'err msg'
        }, 5000)
        return null
      }

      else if (this.form.box_no === '') {
        this.isUsed.visible = true
        this.isUsed.message = 'Box No. ไม่สามารถเว้นว่างได้'
        setTimeout(() => {
          this.isUsed.visible = false,
          this.isUsed.message = 'err msg'
        }, 5000)
        return null
      }

      else if (!this.previewImage) {
        this.isUsed.visible = true
        this.isUsed.message = 'กรุณาแนบใบเสร็จ'
        setTimeout(() => {
          this.isUsed.visible = false,
          this.isUsed.message = 'err msg'
        }, 5000)
        return null
      }
      else {

        if (this.form.phone.length !== 10) {
          this.isUsed.visible = true
          this.isUsed.message = 'กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง'
          setTimeout(() => {
            this.isUsed.visible = false,
            this.isUsed.message = 'err msg'
          }, 5000)
          this.validForm = false
          return null
        }

        const isTelNumber = /[0]{1}[0-9]{9}/.test(this.form.phone)
        if (!isTelNumber) {
          this.isUsed.visible = true
          this.isUsed.message = 'กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง'
          setTimeout(() => {
            this.isUsed.visible = false,
            this.isUsed.message = 'err msg'
          }, 5000)
          this.validForm = false
          return null
        }

        // email
        const isEmail = /.+@.+[.]+./.test(this.form.email)
        if (!isEmail) {
          this.isUsed.visible = true
          this.isUsed.message = 'กรุณากรอกอีเมลให้ถูกต้อง'
          setTimeout(() => {
            this.isUsed.visible = false,
            this.isUsed.message = 'err msg'
          }, 5000)
          this.validForm = false
          return null
        }
        this.validForm = true
      }

    },
  },
}
</script>

<style scoped>
.text-header {
  color: rgb(59, 91, 83);
  font-size: 1.8rem;
  font-weight: 600;
}

.input {
  width: 100%;
  height: 35px;
  border: 1px solid rgb(240, 240, 241);
}

.text-color {
  color: rgb(59, 91, 83);
}

.rules-alert {
  border: 1px red solid;
  background-color: rgb(235, 195, 202);
}

.consent-btn:hover {
  cursor: pointer;
}

.consent-btn {
  text-decoration-line: underline;
}

@media only screen and (max-width: 500px) {
.g-recaptcha {
  transform:scale(0.8);
}
}
.ul, .li{
  margin: 0;
  padding: 0;
  list-style: none;
}

.text-table {
  font-size: 1.8rem;
}

.uploading-image{
  display:flex;
}



.u-section-1 {
  background-image: linear-gradient(0deg, rgba(0,0,0,0.55), rgba(0,0,0,0.55)), url("../../../assets/warranty-images/banner-home1.webp");
  background-position: 50% 50%;
}

.u-section-1 .u-sheet-1 {
  min-height: 366px;
}

.u-section-1 .u-text-1 {
  font-family: Kanit;
  font-size: 3.75rem;
  font-weight: normal;
  margin: 31px 453px 0 0;
}

.u-section-1 .u-text-2 {
  font-size: 1.25rem;
  font-family: Kanit;
  margin: 30px 453px 0 0;
}

.u-section-1 .u-btn-1 {
  background-image: none;
  font-family: Kanit;
  font-size: 1.125rem;
  text-transform: uppercase;
  font-weight: 500;
  margin: 30px auto 31px 264px;
}

@media (max-width: 1199px) {
  .u-section-1 .u-sheet-1 {
    min-height: 330px;
  }

  .u-section-1 .u-text-1 {
    font-size: 3rem;
    width: auto;
    margin-right: 374px;
  }

  .u-section-1 .u-text-2 {
    font-size: 1.125rem;
    width: auto;
    margin-right: 374px;
  }

  .u-section-1 .u-btn-1 {
    margin-left: 193px;
  }
}

@media (max-width: 991px) {
  .u-section-1 .u-sheet-1 {
    min-height: 293px;
  }

  .u-section-1 .u-text-1 {
    font-size: 2.25rem;
    margin-top: 30px;
    margin-right: 282px;
  }

  .u-section-1 .u-text-2 {
    font-size: 1rem;
    margin-right: 282px;
  }

  .u-section-1 .u-btn-1 {
    font-size: 1rem;
    margin-bottom: 30px;
    margin-left: 145px;
  }
}

@media (max-width: 767px) {
  .u-section-1 .u-sheet-1 {
    min-height: 294px;
  }

  .u-section-1 .u-text-1 {
    margin-right: 202px;
  }

  .u-section-1 .u-text-2 {
    margin-right: 202px;
  }

  .u-section-1 .u-btn-1 {
    margin-left: 101px;
  }
}

@media (max-width: 575px) {
  .u-section-1 .u-sheet-1 {
    min-height: 278px;
  }

  .u-section-1 .u-text-1 {
    font-size: 1.75rem;
    margin-top: 35px;
    margin-right: 108px;
  }

  .u-section-1 .u-text-2 {
    font-size: 0.875rem;
    margin-top: 31px;
    margin-right: 109px;
  }

  .u-section-1 .u-btn-1 {
    font-size: 0.875rem;
    margin: 31px 155px 35px 48px;
  }
}.u-section-2 .u-sheet-1 {
  min-height: 495px;
}

.u-section-2 .u-text-1 {
  font-size: 1.875rem;
  background-image: none;
  font-weight: 500;
  margin: 57px 0 0;
}

.u-section-2 .u-list-1 {
  grid-template-rows: auto;
  width: 905px;
  margin: 28px auto 0;
}

.u-section-2 .u-repeater-1 {
  grid-template-columns: calc(33.3333% - 0.666667px) calc(33.3333% - 0.666667px) calc(33.3333% - 0.666667px);
  grid-gap: 1px 1px;
  min-height: 378px;
}

.u-section-2 .u-list-item-1 {
  background-image: none;
}

.u-section-2 .u-container-layout-1 {
  padding: 13px 28px;
}

.u-section-2 .u-image-1 {
  height: 180px;
  width: 185px;
  margin: 17px auto 0;
}

.u-section-2 .u-text-2 {
  font-size: 1.125rem;
  font-weight: 500;
  margin: 26px 0 0 4px;
}

.u-section-2 .u-text-3 {
  font-size: 1.125rem;
  font-family: Kanit;
  margin: 17px 0 0;
}

.u-section-2 .u-list-item-2 {
  background-image: none;
}

.u-section-2 .u-container-layout-2 {
  padding: 13px 28px;
}

.u-section-2 .u-image-2 {
  height: 180px;
  width: 185px;
  margin: 17px auto 0;
}

.u-section-2 .u-text-4 {
  font-size: 1.125rem;
  font-weight: 500;
  font-family: Kanit;
  text-transform: none;
  margin: 26px 0 0 4px;
}

.u-section-2 .u-text-5 {
  font-size: 1.125rem;
  font-family: Kanit;
  margin: 17px 0 0;
}

.u-section-2 .u-list-item-3 {
  background-image: none;
}

.u-section-2 .u-container-layout-3 {
  padding: 13px 28px;
}

.u-section-2 .u-image-3 {
  height: 180px;
  width: 185px;
  margin: 17px auto 0;
}

.u-section-2 .u-text-6 {
  font-size: 1.125rem;
  font-weight: 500;
  font-family: Kanit;
  text-transform: none;
  margin: 26px 0 0 4px;
}

.u-section-2 .u-text-7 {
  font-size: 1.125rem;
  font-family: Kanit;
  margin: 17px 0 0;
}

@media (max-width: 1199px) {
  .u-section-2 .u-repeater-1 {
    min-height: 403px;
  }

  .u-section-2 .u-container-layout-1 {
    padding-left: 11px;
    padding-right: 11px;
    padding-bottom: 3px;
  }

  .u-section-2 .u-image-1 {
    margin-top: 31px;
    margin-right: 52px;
  }

  .u-section-2 .u-text-2 {
    width: auto;
    margin-top: 31px;
  }

  .u-section-2 .u-text-3 {
    width: auto;
    margin-top: 18px;
    margin-right: 11px;
    margin-left: 25px;
  }

  .u-section-2 .u-container-layout-2 {
    padding-left: 11px;
    padding-right: 11px;
    padding-bottom: 3px;
  }

  .u-section-2 .u-image-2 {
    margin-top: 31px;
    margin-right: 52px;
  }

  .u-section-2 .u-text-4 {
    width: auto;
    margin-top: 31px;
  }

  .u-section-2 .u-text-5 {
    width: auto;
    margin-top: 18px;
    margin-right: 11px;
    margin-left: 25px;
  }

  .u-section-2 .u-container-layout-3 {
    padding-left: 11px;
    padding-right: 11px;
    padding-bottom: 3px;
  }

  .u-section-2 .u-image-3 {
    margin-top: 31px;
    margin-right: 52px;
  }

  .u-section-2 .u-text-6 {
    width: auto;
    margin-top: 31px;
  }

  .u-section-2 .u-text-7 {
    width: auto;
    margin-top: 18px;
    margin-right: 11px;
    margin-left: 25px;
  }
}

@media (max-width: 991px) {
  .u-section-2 .u-sheet-1 {
    min-height: 442px;
  }

  .u-section-2 .u-text-1 {
    font-size: 1.5rem;
  }

  .u-section-2 .u-list-1 {
    margin-top: 12px;
    margin-bottom: 4px;
    margin-right: initial;
    margin-left: initial;
    width: auto;
  }

  .u-section-2 .u-repeater-1 {
    min-height: 345px;
  }

  .u-section-2 .u-container-layout-1 {
    padding-left: 18px;
    padding-right: 18px;
    padding-bottom: 18px;
  }

  .u-section-2 .u-image-1 {
    height: 144px;
    width: 148px;
    margin-top: 37px;
    margin-right: auto;
  }

  .u-section-2 .u-text-2 {
    font-size: 1rem;
    margin-top: 20px;
    margin-left: 0;
  }

  .u-section-2 .u-text-3 {
    font-size: 1rem;
    margin-top: 15px;
    margin-left: 0;
    margin-right: 0;
  }

  .u-section-2 .u-container-layout-2 {
    padding-left: 18px;
    padding-right: 18px;
    padding-bottom: 18px;
  }

  .u-section-2 .u-image-2 {
    height: 144px;
    width: 148px;
    margin-top: 37px;
    margin-right: auto;
  }

  .u-section-2 .u-text-4 {
    font-size: 1rem;
    margin-top: 20px;
    margin-left: 0;
  }

  .u-section-2 .u-text-5 {
    font-size: 1rem;
    margin-top: 15px;
    margin-left: 0;
    margin-right: 0;
  }

  .u-section-2 .u-container-layout-3 {
    padding-left: 18px;
    padding-right: 18px;
    padding-bottom: 18px;
  }

  .u-section-2 .u-image-3 {
    height: 144px;
    width: 148px;
    margin-top: 37px;
    margin-right: auto;
  }

  .u-section-2 .u-text-6 {
    font-size: 1rem;
    margin-top: 20px;
    margin-left: 0;
  }

  .u-section-2 .u-text-7 {
    font-size: 1rem;
    margin-top: 15px;
    margin-left: 0;
    margin-right: 0;
  }
}

@media (max-width: 767px) {
  .u-section-2 .u-sheet-1 {
    min-height: 419px;
  }

  .u-section-2 .u-repeater-1 {
    min-height: 322px;
  }

  .u-section-2 .u-container-layout-1 {
    padding-left: 10px;
    padding-right: 10px;
  }

  .u-section-2 .u-image-1 {
    height: 127px;
    width: 137px;
    margin-top: 42px;
  }

  .u-section-2 .u-text-2 {
    margin-top: 15px;
  }

  .u-section-2 .u-container-layout-2 {
    padding-left: 10px;
    padding-right: 10px;
  }

  .u-section-2 .u-image-2 {
    height: 127px;
    width: 137px;
    margin-top: 42px;
  }

  .u-section-2 .u-text-4 {
    margin-top: 15px;
  }

  .u-section-2 .u-container-layout-3 {
    padding-left: 10px;
    padding-right: 10px;
  }

  .u-section-2 .u-image-3 {
    height: 127px;
    width: 137px;
    margin-top: 42px;
  }

  .u-section-2 .u-text-6 {
    margin-top: 15px;
  }
}

@media (max-width: 575px) {
  .u-section-2 .u-sheet-1 {
    min-height: 330px;
  }

  .u-section-2 .u-text-1 {
    font-size: 1.25rem;
    width: auto;
    margin-top: 31px;
  }

  .u-section-2 .u-list-1 {
    margin-top: 18px;
    width: auto;
    margin-right: initial;
    margin-left: initial;
  }

  .u-section-2 .u-repeater-1 {
    grid-gap: 2px 2px;
    min-height: 233px;
    grid-template-columns: calc(33.3333% - 1.33333px) calc(33.3333% - 1.33333px) calc(33.3333% - 1.33333px);
  }

  .u-section-2 .u-container-layout-1 {
    padding-bottom: 14px;
  }

  .u-section-2 .u-image-1 {
    height: 84px;
    width: 78px;
    margin-top: 9px;
    margin-right: 7px;
    margin-left: 7px;
  }

  .u-section-2 .u-text-2 {
    font-size: 0.875rem;
    margin-top: 20px;
  }

  .u-section-2 .u-text-3 {
    font-size: 0.75rem;
    margin-top: 4px;
  }

  .u-section-2 .u-container-layout-2 {
    padding-bottom: 14px;
  }

  .u-section-2 .u-image-2 {
    height: 84px;
    width: 78px;
    margin-top: 9px;
    margin-right: 7px;
    margin-left: 7px;
  }

  .u-section-2 .u-text-4 {
    font-size: 0.875rem;
    margin-top: 20px;
  }

  .u-section-2 .u-text-5 {
    font-size: 0.75rem;
    margin-top: 4px;
  }

  .u-section-2 .u-container-layout-3 {
    padding-bottom: 14px;
  }

  .u-section-2 .u-image-3 {
    height: 84px;
    width: 78px;
    margin-top: 9px;
    margin-right: 7px;
    margin-left: 7px;
  }

  .u-section-2 .u-text-6 {
    font-size: 0.875rem;
    margin-top: 20px;
  }

  .u-section-2 .u-text-7 {
    font-size: 0.75rem;
    margin-top: 4px;
  }
}.u-section-3 .u-sheet-1 {
  min-height: 987px;
}

.u-section-3 .u-layout-wrap-1 {
  margin-top: 41px;
  margin-bottom: 0;
}

.u-section-3 .u-layout-cell-1 {
  min-height: 946px;
}

.u-section-3 .u-container-layout-1 {
  padding: 0 30px 96px;
}

.u-section-3 .u-text-1 {
  font-size: 1.5rem;
  font-weight: 500;
  text-transform: none;
  margin: 0;
}

.u-section-3 .u-form-1 {
  height: 768px;
  margin: 53px 154px 0 184px;
}

.u-section-3 .u-label-1 {
  font-size: 1.125rem;
  font-family: Kanit;
}

.u-section-3 .u-input-1 {
  font-family: Kanit;
}

.u-section-3 .u-form-group-2 {
  margin-left: 0;
}

.u-section-3 .u-label-2 {
  font-size: 1.125rem;
  font-family: Kanit;
}

.u-section-3 .u-input-2 {
  font-family: Kanit;
}

.u-section-3 .u-form-group-3 {
  margin-left: 0;
}

.u-section-3 .u-label-3 {
  font-size: 1.125rem;
  font-family: Kanit;
}

.u-section-3 .u-input-3 {
  font-family: Kanit;
}

.u-section-3 .u-form-group-4 {
  margin-left: 0;
}

.u-section-3 .u-label-4 {
  font-size: 1.125rem;
  font-family: Kanit;
}

.u-section-3 .u-input-4 {
  font-family: Kanit;
}

.u-section-3 .u-form-group-5 {
  margin-left: 0;
}

.u-section-3 .u-label-5 {
  font-size: 1.125rem;
  font-family: Kanit;
}

.u-section-3 .u-input-5 {
  font-family: Kanit;
}

.u-section-3 .u-form-group-6 {
  margin-left: 0;
}

.u-section-3 .u-label-6 {
  font-size: 1.125rem;
  font-family: Kanit;
}

.u-section-3 .u-input-6 {
  font-family: Kanit;
}

.u-section-3 .u-form-group-7 {
  margin-left: 0;
}

.u-section-3 .u-label-7 {
  font-size: 1.125rem;
  font-family: Kanit;
}

.u-section-3 .u-input-7 {
  font-family: Kanit;
}

.u-section-3 .u-label-8 {
  font-size: 1.125rem;
  font-family: Kanit;
}

.u-section-3 .u-input-8 {
  font-family: Kanit;
}

.u-section-3 .u-form-group-9 {
  margin-left: 0;
}

.u-section-3 .u-label-9 {
  font-size: 1.125rem;
  font-family: Kanit;
}

.u-section-3 .u-btn-1 {
  border-style: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  background-image: none;
  width: 100%;
  font-weight: 700;
  font-family: Kanit;
  font-size: 1.125rem;
}

@media (max-width: 1199px) {
  .u-section-3 .u-sheet-1 {
    min-height: 890px;
  }

  .u-section-3 .u-layout-cell-1 {
    background-position: 50% 50%;
    min-height: 895px;
  }

  .u-section-3 .u-container-layout-1 {
    padding-bottom: 48px;
  }

  .u-section-3 .u-form-1 {
    margin-right: 54px;
    margin-left: 84px;
  }
}

@media (max-width: 991px) {
  .u-section-3 .u-sheet-1 {
    min-height: 200px;
  }

  .u-section-3 .u-layout-cell-1 {
    min-height: 853px;
  }

  .u-section-3 .u-container-layout-1 {
    padding-bottom: 30px;
  }

  .u-section-3 .u-text-1 {
    font-size: 1.25rem;
  }

  .u-section-3 .u-form-1 {
    margin-right: 0;
    margin-left: 0;
  }

  .u-section-3 .u-label-1 {
    font-size: 1rem;
  }

  .u-section-3 .u-label-2 {
    font-size: 1rem;
  }

  .u-section-3 .u-label-3 {
    font-size: 1rem;
  }

  .u-section-3 .u-label-4 {
    font-size: 1rem;
  }

  .u-section-3 .u-label-5 {
    font-size: 1rem;
  }

  .u-section-3 .u-label-6 {
    font-size: 1rem;
  }

  .u-section-3 .u-label-7 {
    font-size: 1rem;
  }

  .u-section-3 .u-label-8 {
    font-size: 1rem;
  }

  .u-section-3 .u-label-9 {
    font-size: 1rem;
  }
}

@media (max-width: 767px) {
  .u-section-3 .u-sheet-1 {
    min-height: 892px;
  }

  .u-section-3 .u-layout-cell-1 {
    min-height: 851px;
  }

  .u-section-3 .u-container-layout-1 {
    padding-left: 10px;
    padding-right: 10px;
  }
}

@media (max-width: 575px) {
  .u-section-3 .u-sheet-1 {
    min-height: 908px;
  }

  .u-section-3 .u-layout-wrap-1 {
    margin-top: 29px;
    margin-bottom: 12px;
  }

  .u-section-3 .u-layout-cell-1 {
    min-height: 858px;
  }

  .u-section-3 .u-container-layout-1 {
    padding-left: 9px;
    padding-right: 9px;
    padding-bottom: 73px;
  }

  .u-section-3 .u-text-1 {
    font-size: 1.125rem;
    margin-left: 1px;
    margin-right: 1px;
  }

  .u-section-3 .u-form-1 {
    height: 732px;
    width: 320px;
    margin-top: 32px;
    margin-left: auto;
    margin-right: auto;
  }

  .u-section-3 .u-label-1 {
    font-size: 0.875rem;
  }

  .u-section-3 .u-label-2 {
    font-size: 0.875rem;
  }

  .u-section-3 .u-label-3 {
    font-size: 0.875rem;
  }

  .u-section-3 .u-label-4 {
    font-size: 0.875rem;
  }

  .u-section-3 .u-label-5 {
    font-size: 0.875rem;
  }

  .u-section-3 .u-label-6 {
    font-size: 0.875rem;
  }

  .u-section-3 .u-label-7 {
    font-size: 0.875rem;
  }

  .u-section-3 .u-label-8 {
    font-size: 0.875rem;
  }

  .u-section-3 .u-label-9 {
    font-size: 0.875rem;
  }
}

</style>
